import { useMemo } from 'react';

/**
 * Hook to access Tailwind theme values from CSS variables (Tailwind v4)
 * Returns theme object compatible with v3 structure for backward compatibility
 */
function useTailwindTheme() {
    return useMemo(() => {
        if (typeof window === 'undefined') {
            return null;
        }

        const styles = getComputedStyle(document.documentElement);

        // Helper to get CSS variable value
        const getVar = (name) => styles.getPropertyValue(name).trim();

        return {
            screens: {
                sm: getVar('--breakpoint-sm') || '375px',
                md: getVar('--breakpoint-md') || '700px',
                lg: getVar('--breakpoint-lg') || '1024px',
                xl: getVar('--breakpoint-xl') || '1240px',
                '2xl': getVar('--breakpoint-2xl') || '1440px',
                '3xl': getVar('--breakpoint-3xl') || '1920px',
            },
            colors: {
                kale: getVar('--color-kale') || '#2E8540',
                'kale-hover': getVar('--color-kale-hover') || '#1E582A',
                lime: getVar('--color-lime') || '#D7E1B8',
                malt: getVar('--color-malt') || '#FFF9EA',
                beet: getVar('--color-beet') || '#B32274',
                'beet-hover': getVar('--color-beet-hover') || '#7D1851',
                strawberry: getVar('--color-strawberry') || '#F0D3E3',
                oat: getVar('--color-oat') || '#F4F0F2',
                mango: getVar('--color-mango') || '#F1C34A',
                black: getVar('--color-black') || '#2D2D2D',
                grey: getVar('--color-grey') || '#666666',
                'grey-light': getVar('--color-grey-light') || '#C3C3C3',
                'grey-dark': getVar('--color-grey-dark') || '#969696',
                'off-white': getVar('--color-off-white') || '#F8F2ED',
                white: getVar('--color-white') || '#ffffff',
                success: getVar('--color-success') || '#75B543',
                warning: getVar('--color-warning') || '#DEA455',
                error: getVar('--color-error') || '#D9291F',
                info: getVar('--color-info') || '#63ACDE',
                perks: getVar('--color-perks') || '#E5F2E0',
                transparent: getVar('--color-transparent') || 'transparent',
                blueberry: getVar('--color-blueberry') || '#44638D',
                'blueberry-hover': getVar('--color-blueberry-hover') || '#304563',
                concord: getVar('--color-concord') || '#6784AC',
                cranberry: getVar('--color-cranberry') || '#A13051',
                guava: getVar('--color-guava') || '#F594A4',
            },
        };
    }, []);
}

export default useTailwindTheme;
